import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-frequently',
  templateUrl: './frequently.component.html',
  styleUrls: ['./frequently.component.css']
})
export class FrequentlyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
